import { required } from "@/utils";
import { appConfig } from "@/config";
import store from "@/store";
import { isType } from "@/utils/common.utils";

/** Application default locale */
const { defaultLocale } = appConfig;

/**
 * Calculates the percentage of the records
 * @param {Number} from Sum of the records
 * @param {Number} total total
 * @returns {Number} percentage
 */
export const percent = (from = required(), total = required()) => {
  if (!from) return 0;
  return ((from * 100) / total).toFixed(2);
};

/**
 * Fomates date in am pm format
 * @param {String} Date in string format
 * @returns {String} Date formatted in ( Feb 9, 2021 at 7:18 am ) format
 */
export const formatDateToAmPm = function(value) {
  if (!value) return value;

  const preferredTimeZone = store.getters["auth/timezone"];
  let date = new Date(value);

  if (preferredTimeZone) {
    date = new Date(
      date.toLocaleString(defaultLocale, { timeZone: preferredTimeZone })
    );
  }

  const dateFormat = preferredTimeZone
    ? `${date.getMonthName()} ${date.getDate()}, ${date.getFullYear()} at ${date.formatAmPm(
        false
      )}`
    : `${date.getMonthName()} ${date.getUTCDate()}, ${date.getUTCFullYear()} at ${date.formatAmPm()}`;

  return dateFormat;
};

/**
 * Capitalizes the first character of the string
 * @param {String} str String to be capitalised
 * @returns {String} Capitalized string
 */
export const capitalize = (str) => {
  if (!str && !isType(str, "string")) return str;

  const capitalizedStr = `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  return capitalizedStr;
};
